import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';

import { ProfileIntroEditDialogComponent } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.component';

import { Account } from '@libs/src/models/account.model';
import { SetUser } from '@libs/src/user/user.actions';
import { IAppState } from '@main-client/src/app/app.state';
import { Profile } from '@main-client/src/app/profile/profile';

@Injectable()
export class ProfileIntroEditDialogService {
  constructor(
    private dialog: MatDialog,
    private store: Store<IAppState>,
  ) {}

  openEditDialog(
    isUser: boolean,
    profile: Profile,
    user: Account,
    focusElement?: string,
  ) {
    const dialogRef = this.dialog.open(ProfileIntroEditDialogComponent, {
      autoFocus: false,
      closeOnNavigation: true,
      data: { focusElement, profile, user },
      disableClose: true,
      maxWidth: '600px',
      width: '95vw',
    });
    return dialogRef.afterClosed().pipe(
      filter((dialogResponse: any) => !!dialogResponse && isUser),
      tap((updatedUser: Account) => {
        this.store.dispatch(SetUser(updatedUser));
      }),
    );
  }
}
